import { css, unsafeCSS } from "lit";
const genericTransition = (selector, properties) => css`
    ${unsafeCSS(selector)} {
        transition-timing-function: ease-in-out;
        transition-duration: 0.2s;
        /* stylelint-disable-next-line function-name-case */
        transition-property: ${unsafeCSS(properties)};
    }
`;
export { genericTransition };
